import { Alert } from '@mui/material';
import { useParams } from 'react-router';
import { useHealthcareServices } from 'src/careflow/ph-core/fhir-client/fhir-react';
import fhirSystem from 'src/ccm/fhir/system';
import NewProgramForm from '../new';

export default function EditProgram() {
  const { program: programId = '' } = useParams();
  const [[program], { isLoading }] = useHealthcareServices({
    filter: {
      identifier: fhirSystem.program.forCode(programId),
    },
  });

  if (!program && !isLoading) return <Alert severity="error">Plan not found</Alert>;
  return <NewProgramForm isEdit currentProgram={program!} />;
}
